import { render, staticRenderFns } from "./uploadChoose.vue?vue&type=template&id=a5a16790&scoped=true&"
import script from "./uploadChoose.vue?vue&type=script&lang=js&"
export * from "./uploadChoose.vue?vue&type=script&lang=js&"
import style0 from "./uploadChoose.vue?vue&type=style&index=0&id=a5a16790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a16790",
  null
  
)

export default component.exports